import { useUserStore } from '@modules/user/stores/user.store'

import { isOnboardingAlreadyComplete } from '../utils/isOnboardingAlreadyComplete'
import { runOnboardingWorkspaceSetup } from '../utils/runOnboardingWorkspaceSetup'

import { useOnboardingStore } from './onboarding.store'

export async function ensureOnboardingComplete(): Promise<void> {
  if (isOnboardingAlreadyComplete()) {
    return
  }

  const userAfterInitialization = useUserStore.getState().currentUser
  if (!userAfterInitialization) {
    return
  }

  const { startOnboarding, setCurrentStep, completeOnboarding, setError } = useOnboardingStore.getState()

  try {
    startOnboarding()
    setCurrentStep('workspace')

    await runOnboardingWorkspaceSetup()

    if (!isOnboardingAlreadyComplete()) {
      throw new Error('Workspace and project were not ready after onboarding setup')
    }

    setCurrentStep('project')
    setCurrentStep('complete')
    completeOnboarding()
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Onboarding process failed.'
    setError(errorMessage)
    throw error
  }
}
